export function hasElapsedTime(initialTime: number | undefined, offset: number): boolean {
  // Si no hay tiempo inicial, consideramos que debe hacer fetch
  if (initialTime === undefined) {
    return true
  }

  const currentTime = Date.now() // Más eficiente que new Date().getTime()
  const difference = currentTime - initialTime

  return difference >= offset
}
